import React from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Star from "@mui/icons-material/Star";
import StarBorder from "@mui/icons-material/StarBorder";

const GOAL_STARRED_VALUE = "2025";

/**
 * @param {object} props
 * @param {("2025"|"not-set"|undefined)} props.personalGoal
 * @param {(value: ("2025"|"not-set")) => void} props.onToggle
 */
export const StarGoalButton = ({ personalGoal, onToggle }) => {
  const isStarred = personalGoal === GOAL_STARRED_VALUE;

  const handleClick = () => {
    onToggle(isStarred ? "not-set" : GOAL_STARRED_VALUE);
  };

  const tooltipText = isStarred ? "Starred games are easier to access." : "Star this game to make it easier to access.";

  return (
    <Tooltip title={tooltipText}>
      <IconButton
        onClick={handleClick}
        color={isStarred ? "primary" : "default"}
        aria-label={isStarred ? "Unstar game for quick access" : "Star game for quick access"}
        aria-pressed={isStarred}
      >
        {isStarred ? <Star /> : <StarBorder />}
      </IconButton>
    </Tooltip>
  );
};
